
export class Constants {
    static device_already_connected: string = "Device is already connected to";
}